import styled from 'styled-components'

export const StyledContainerItem = styled.div`
    display: flex; 
    flex-direction: ${props => props.theme ? 'row' : 'column'}
`;